import { Avatar, Box, Button, CircularProgress, Grid2 as Grid, MenuItem, Stack } from "@mui/material"
import { handleUpdateProfileReq } from "../../../../redux/user-slices/auth.slice"
import { updateDetailsSchema } from "../../../../utils/velidations"
import InputFieldB from "../../../../components/ui/InputFieldB"
import { useDispatch, useSelector } from "react-redux"
import Icons from "../../../../assets/js/Icons"
import { useNavigate } from "react-router-dom"
import { useState } from "react"


function EditProfile() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [preview, setPreview] = useState(null)
  const [helperText, setHelperText] = useState([])
  const { member } = useSelector((state) => state.authSlice)
  const { loadings } = useSelector((state) => state.otherSlice)

  const validatePhone = (e) => {
    let value = e.target?.value;
    const allowedChars = /[^0-9+]/g;
    value = value.slice(0, 10);
    const filteredValue = value.replace(allowedChars, "");
    e.target.value = filteredValue;
  };

  const validateZip = (e) => {
    let value = e.target?.value;
    const allowedChars = /[^0-9]/g;
    value = value.slice(0, 6);
    const filteredValue = value.replace(allowedChars, "");
    e.target.value = filteredValue;
  };

  const handleUpdatePassword = (e) => {
    e.preventDefault()

    const formData = new FormData(e.target)

    const plain = Object.fromEntries(formData.entries())
    const result = updateDetailsSchema.safeParse(plain)

    if (!result.success) {
      const groupedErrors = {}
      result.error.issues.forEach((issue) => {
        const key = issue.path[0]
        if (!groupedErrors[key]) {
          groupedErrors[key] = []
        }
        groupedErrors[key].push(issue.message)
      })
      setHelperText(groupedErrors)
      return
    }

    setHelperText([])

    dispatch(handleUpdateProfileReq(formData))
      .unwrap()
      .then(() => {
        e.target.reset()
        setPreview(null)
        navigate("/member/profile")
      })
      .catch(() => { })
  }

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setPreview(URL.createObjectURL(file))
    }
  }
  return (
    <Box
      component="form"
      onSubmit={handleUpdatePassword}
      sx={{
        height: "100%",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <Stack direction="row" spacing={2} mb={3} alignItems="center">
        <Avatar
          sx={{
            width: { xs: 100, md: 150, xl: 180 },
            height: { xs: 100, md: 150, xl: 180 },
          }}
          src={preview || member?.image || ""}
        />
        <Button
          variant="contained"
          component="label"
          startIcon={<Icons.UploadSolid />}
        >
          Upload Photo
          <input
            type="file"
            hidden
            accept="image/*"
            name="image"
            onChange={handleImageChange}
          />
        </Button>
      </Stack>

      <Grid container spacing={3} gap={3}>
        <Grid size={{ xs: 12, lg: 12, xl: 5 }}>
          <InputFieldB
            name="fullName"
            label={
              <>
                Full Name <span style={{ color: "red" }}>*</span>
              </>
            }
            inputtype="InputFieldB"
            helperText={helperText}
            placeholder="Enter full name"
            defaultValue={member?.fullName || ""}
          />
          <InputFieldB
            name="username"
            label={
              <>
                Username <span style={{ color: "red" }}>*</span>
              </>
            }
            inputtype="InputFieldB"
            helperText={helperText}
            placeholder="Enter username"
            defaultValue={member?.username || ""}
          />
          <InputFieldB
            name="email"
            label={
              <>
                Email <span style={{ color: "red" }}>*</span>
              </>
            }
            type="email"
            inputtype="InputFieldB"
            helperText={helperText}
            placeholder="Enter email"
            defaultValue={member?.email || ""}
          />

          <InputFieldB
            name="phone"
            label={
              <>
                Phone no. <span style={{ color: "red" }}>*</span>
              </>
            }
            inputtype="InputFieldB"
            helperText={helperText}
            placeholder="Enter Phone number"
            onChange={validatePhone}
            defaultValue={member?.phone ? member.phone : ""}
          />

          <InputFieldB
            name="zip"
            label={
              <>
                Zip Code <span style={{ color: "red" }}>*</span>
              </>
            }
            inputtype="InputFieldB"
            helperText={helperText}
            placeholder="Enter zip code"
            onChange={validateZip}
            defaultValue={member?.address?.zip || ""}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 12, xl: 5 }}>
          <InputFieldB
            name="country"
            label={
              <>
                Country <span style={{ color: "red" }}>*</span>
              </>
            }
            inputtype="InputFieldB"
            placeholder="Enter country"
            helperText={helperText}
            defaultValue={member?.address?.country || ""}
          />
          <InputFieldB
            name="state"
            label={
              <>
                State <span style={{ color: "red" }}>*</span>
              </>
            }
            inputtype="InputFieldB"
            placeholder="Enter state"
            helperText={helperText}
            defaultValue={member?.address?.state || ""}
          />
          <InputFieldB
            name="city"
            label={
              <>
                City <span style={{ color: "red" }}>*</span>
              </>
            }
            inputtype="InputFieldB"
            placeholder="Enter city"
            helperText={helperText}
            defaultValue={member?.address?.city || ""}
          />
          <InputFieldB
            name="street"
            label={
              <>
                Street <span style={{ color: "red" }}>*</span>
              </>
            }
            inputtype="InputFieldB"
            placeholder="Enter street"
            helperText={helperText}
            defaultValue={member?.address?.street || ""}
          />{" "}
          <InputFieldB
            select
            SelectProps={{ displayEmpty: true }}
            name="bloodGroup"
            label={
              <>
                BloodGroup <span style={{ color: "red" }}>*</span>
              </>
            }
            inputtype="InputFieldB"
            placeholder="Enter blood group"
            helperText={helperText}
            defaultValue={member?.bloodGroup || ""}
          >
            <MenuItem value="" disabled>
              Select Blood Group
            </MenuItem>
            {["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </InputFieldB>
        </Grid>
      </Grid>

      <Button
        type="submit"
        variant="contained"
        disabled={Boolean(loadings?.update)}
        sx={{
          mt: 2,
          fontSize: "18px",
          justifyContent: "center",
        }}
        endIcon={
          loadings?.update && (
            <CircularProgress size={22} color="text" thickness={6} />
          )
        }
      >
        Update Profile
      </Button>
    </Box>
  )
}

export default EditProfile
